import { Platform } from 'root/src/shared/@types/platforms';
export function getReadablePlatform(platform) {
    switch (platform) {
        case Platform.Twitch:
            return 'Twitch';
        case Platform.TikTok:
            return 'TikTok';
        case Platform.YouTube:
            return 'YouTube';
        default:
            return undefined;
    }
}
